let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9YZxv")).then(() => parcelRequire('aqLmU'));